import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { BehaviorSubject, combineLatest, filter, map, Observable, shareReplay } from 'rxjs';

import { ClientsDao } from '../../../data/daos/clients.dao';
import { ReportPage } from '../../../data/models/clients.model';
import { NavTool, routeToNavTool } from './nav.config';

@Injectable({
	providedIn: 'root',
})
export class SideNavService {
	private readonly selectedToolSubject = new BehaviorSubject<NavTool | null>(null);
	readonly selectedTool$ = this.selectedToolSubject.asObservable();

	private readonly embedReportPagesSubject = new BehaviorSubject<ReportPage[]>([]);

	readonly reportPages$: Observable<ReportPage[]>;

	isCollapsed = false;

	get selectedTool() {
		return this.selectedToolSubject.value;
	}

	constructor(
		private router: Router,
		private clientsDao: ClientsDao,
	) {
		this.reportPages$ = combineLatest([
			this.clientsDao.streamActiveClient().pipe(map((client) => client.reportPages ?? [])),
			this.embedReportPagesSubject.asObservable(),
		]).pipe(
			map(([clientPages, embedPages]) => (embedPages.length ? embedPages : clientPages)),
			shareReplay(1),
		);

		this.syncFromRoute();
		this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
			this.syncFromRoute();
		});
	}

	toggleCollapsed() {
		this.isCollapsed = !this.isCollapsed;
	}

	selectTool(tool: NavTool) {
		this.selectedToolSubject.next(tool);
		this.isCollapsed = false;
	}

	setEmbedReportPages(pages: ReportPage[]) {
		this.embedReportPagesSubject.next(pages);
	}

	private syncFromRoute() {
		const tool = routeToNavTool(this.router.url);
		if (tool != null) {
			this.selectedToolSubject.next(tool);
		}
	}
}
